module.exports = __webpack_public_path__ + "4f4c3b3e9621b9750a7ded8ef809b165.svg";